import styled from "@emotion/styled";

import { StyledAdSlot } from "scmp-app/components/article/article-render/styles";
import { ContentNewsletterWidget } from "scmp-app/components/content/content-newsletter-widget";
import { ContentShareWidget } from "scmp-app/components/content/content-share-widget";
import { setFullViewportWidthStyles, ZIndexLayer } from "scmp-app/lib/styles";
import type { WithStickyStackedHeightProps } from "scmp-app/lib/styles";

import { SeriesArticleBanner } from "./banner";
import { SeriesArticleItem } from "./item";
import { SeriesArticleOtherScmpSeries } from "./other-scmp-series";
import { SeriesArticlePager } from "./pager";

export const Container = styled.div`
  min-block-size: 1200px;
  ${setFullViewportWidthStyles()}
  *::selection {
    background: #ffe999;
  }
`;

const MobileAdSlot = styled.div`
  ${setFullViewportWidthStyles()}
  ${StyledAdSlot} {
    inline-size: fit-content;
    margin: auto;
  }
`;

export const MobileAdSlotOne = styled(MobileAdSlot)`
  min-block-size: 314px;
  margin-block-end: 48px;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const MobileAdSlotTwo = styled(MobileAdSlot)`
  display: block;

  margin-block-end: 48px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 60px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const MobileAdSlotThree = styled(MobileAdSlot)`
  display: block;

  min-block-size: 314px;
  ${props => props.theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const BannerAdSlot = styled.div`
  display: none;

  padding-block: 32px;
  padding-inline: 38px;

  background-color: rgba(247, 247, 247, 0.9);
  ${props => props.theme.breakpoints.up("desktop")} {
    display: block;
  }
`;

export const SecondBannerAdSlot = styled(BannerAdSlot)`
  margin-block-end: 60px;
`;

export const NativeAdSlot = styled.div`
  margin-block: 0 20px;
  margin-inline: 20px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-inline: 44px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 680px;
    margin-inline: auto;
    padding-block: 0;
    padding-inline: 20px;
  }
`;

export const ShareBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-block-end: 60px;
`;

export const ShareDivider = styled.div`
  inline-size: 64px;
  block-size: 4px;
  margin-block-end: 28px;

  background-color: #001246;
`;

export const StyledSeriesArticleBanner = styled(SeriesArticleBanner)``;
export const StyledContentNewsletterWidget = styled(ContentNewsletterWidget)``;
export const StyledSeriesArticlePager = styled(SeriesArticlePager)<WithStickyStackedHeightProps>`
  position: sticky;
  inset-block-start: ${props => props.$stickyStackedHeight}px;
  z-index: ${ZIndexLayer.AppBar - 1};

  margin-block-end: 40px;

  ${props => props.theme.breakpoints.down("tablet")} {
    display: none;
  }
`;
export const StyledSeriesArticleOtherScmpSeries = styled(SeriesArticleOtherScmpSeries)``;

export const StyledSeriesArticleItem = styled(SeriesArticleItem)`
  max-inline-size: 1368px;
  margin-block-end: 48px;
  margin-inline: auto auto;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 36px;
  }
`;

export const NewsletterWidgetContainer = styled.div`
  inline-size: 100%;
  margin-block: 0 48px;
  margin-inline: auto auto;
  padding-inline: 19px;
  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 504px;
  }
`;

export const NewsletterWidgetWrapper = styled.div`
  display: flex;
  justify-content: center;

  inline-size: 100%;
  padding-block: 16px;
  padding-inline: 19px;

  border: 1px solid #000000;
  border-width: 1px 0;
`;

export const StyledContentShareWidget = styled(ContentShareWidget)`
  display: flex;
  div {
    inline-size: 40px;
    block-size: 21px;
    padding: 0;
  }

  .facebook svg {
    transform: scale(0.9);
  }
  .twitter svg {
    transform: scale(0.9);
  }
  .copy-link svg {
    transform: scale(0.9);
  }
  .email svg {
    transform: scale(0.9);
  }
`;
